import { EventEmitter, Injectable } from '@angular/core';

// interfaces 
import { IPedido } from '../interfaces/pedido';

// servicios
import { UsuarioService } from './datos/usuario.service';

// librerías y entronos
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IAvisosOpciones } from '../pages/tablas/avisos/avisosListOpciones';
import { IAvisos } from '../interfaces/avisos';
import { AvisosService } from './datos/avisos.service';
import { NotificacionesService } from './notificaciones.service';


@Injectable({
  providedIn: 'root'
})
export class ModalAvisoPedidoService {
  apiURL: string = environment.apiURL;

  private _ocultarModal: boolean = true;
  private _pedido: any;

  loading: boolean = false;
  avisosList: IAvisos[] = [];

  pedidoSubject: Subject<IPedido> = new Subject<IPedido>();
  modalClosed: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private usuarioSrv: UsuarioService,
    private avisosSrv: AvisosService,
    private notificSrv: NotificacionesService
  ) { }


  get pedido(): any {
    return this._pedido;
  }

  set pedido(value: any) {
    this._pedido = value;
    this.pedidoSubject.next(value);
  }

  get ocultarModal() {
    return this._ocultarModal;
  }


  abrirModal() {
    this._ocultarModal = false;
    this.getListaAvisos();
  }

  cerrarModal() {
    // cerrar modal y emitir 'modalClosed' para que el subscriptor se entere
    this._ocultarModal = true;
    this.avisosList = [];
    this.modalClosed.emit();
  }

  getListaAvisos() {
    const avisosOpciones: IAvisosOpciones = {}
    avisosOpciones.buscar_pedido = this.pedido!.id;
   // avisosOpciones.tipo = '1';
    this.loading = true;
    this.avisosSrv.getAvisosList(avisosOpciones)
      .subscribe(resp => {
        this.loading = false;

        // Solo pedidos ó genéricos
        this.avisosList = resp.data; 
        if (this.avisosList.length == 0) {
          this.notificSrv.aviso('info', 'No se encontraron notificaciones para este pedido');
        }
      })
  }


  ///// AUX ////

  errorAuth() {
    this.usuarioSrv.logOut();
    console.log('error', environment.apiErrorAuth);
    // this.notificacionesSrv.aviso('error', environment.apiErrorAuth);
  }

}
